const MY_API_KEY = "AIzaSyDgTUN2utT4pgYIrbALwnPpBX_gx3f59Jc";
//  "AIzaSyCXaq5vwNytwi6ujUstu6lYfNRfEAq3XUM";

export const YOUTUBE_VIDEO_API =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key=" +
  MY_API_KEY;

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export const DOG_API = "https://dog.ceo/api/breeds/image/random";
